import React from 'react';
import TablaServices from '../../components/tables/Services';

const ServicesPage = () => {
    return (
        <TablaServices/>
    );
}
 
export default ServicesPage;